
import React, { useState } from "react";
import { submitFirmDetails } from "../../auth/services/privateapicalling";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { toast } from "react-toastify";

interface PartnersProps {
  onNext: (data: any) => void;
  onPrev: () => void;
  isFirmDetailFilled:boolean;
  existData:any;
  applicationId:string | null;
}

const Partners: React.FC<PartnersProps> = ({ onNext, onPrev,existData, applicationId,isFirmDetailFilled}) => {
  const [entityName, setEntityName] = useState(existData?.entityName || "");
  const [entityRegistrationNo, setEntityRegistrationNo] = useState(existData?.entityRegistrationNo || "");
  const [entityGstNo, setEntityGstNo] = useState(existData?.entityGstNo || "");
  const [entityPanNo, setEntityPanNo] = useState(existData?.entityPanNo || "");
  const [entityFpoNo, setEntityFpoNo] = useState(existData?.entityFpoNo || "");
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const [partners, setPartners] = useState(existData?.firmRepresentatives?.length > 0
    ? existData.firmRepresentatives
    : [{ name: "", age: "", address: "" }]);
  const token = useSelector((state: any) => state.auth.token);
     const formLanguage = useSelector((state: any) => state.auth.formLanguage)
  
   const language = useSelector((state:any)=>state.auth.language);
  const userdetails = useSelector((state: any) => state.auth.userDetails);
    const applicationIdRedux = useSelector((state:any)=>state.auth.applicationId);
  const appId = userdetails.applicationId ? userdetails.applicationId : applicationIdRedux;
  //.log("appp id that pass to representatives", appId)

  const handlePartnerChange = (index: number, field: string, value: string) => {
    const updatedPartners = [...partners];
    updatedPartners[index] = { ...updatedPartners[index], [field]: value };
    setPartners(updatedPartners);
  };



  const handleAddPartner = () => {
    setPartners([...partners, { name: "", age: "", address: "" }]);
  };

  const handleDeletePartner = (index: number) => {
    const updatedPartners = partners.filter((_: any, i: number) => i !== index);
    setPartners(updatedPartners);
  };

  const validationForm = async () => {
    try {
      await entitySchema.validate(
        {
          entityName,
          entityGstNo,
          entityFpoNo,
          entityPanNo,
          entityRegistrationNo,
        },
        { abortEarly: false }
      );
      setErrors({});
      return true;
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const newErrors: { [key: string]: string } = {};
        err.inner.forEach((error) => {
          if (error.path) {
            newErrors[error.path] = error.message;
          }
        });
        setErrors(newErrors);
      }
      return false;
    }
  };
   const [partnerErrors, setPartnerErrors] = useState<{ partners: { name?: string; age?: string; address?: string }[] }>({
    partners: [],
   });
 
  const validationPartnerSchema = Yup.object().shape({
    partners: Yup.array().of(
         Yup.object().shape({
           name: Yup.string()
             .matches(/^[A-Za-z\s]+$/, "Only alphabets and spaces are allowed, no special characters")
             .max(40, "Name must not exceed 40 characters including spaces")
             .required("Name is required"),
           age: Yup.number()
             .typeError("Age must be a number")
             .min(1, "Age must be at least 1")
             .max(120, "Age must be less than or equal to 120")
             .required("Age is required"),
             address:  Yup.string().matches( /^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/,
                 "Only alphabets, spaces,numbers and the following special characters are allowed: + / ' , ."
               ).max(100, "Address must not exceed 100 characters")
             .required("Address is required"),
         })
       )
     });
     const validationPartnerForm = async () => {
      try {
        //.log("Validating partner form...");
        await validationPartnerSchema.validate(
          { partners }, // Fix: Correct key name
          { abortEarly: false }
        );
    
        setPartnerErrors({ partners: partners.map(() => ({})) }); // Reset errors
        //.log("✅ Partner validation successful");
        return true;
      } catch (err: any) {
        //.log("❌ Partner validation errors:", err);
    
        const newErrors: any = { partners: partners.map(() => ({})) };
    
        err.inner.forEach((error: any) => {
          const pathParts = error.path.match(/partners\[(\d+)]\.(\w+)/);
          if (pathParts) {
            const index = parseInt(pathParts[1], 10);
            const field = pathParts[2];
    
            if (!newErrors.partners[index]) newErrors.partners[index] = {};
            newErrors.partners[index][field] = error.message;
          }
        });
    
        setPartnerErrors(newErrors);
        return false;
      }
    };

    // const validationPartnerForm = async () => {
    //   try {
    //     //.log("Validating partner form...");
    //     await validationPartnerSchema.validate(
    //       { partners: partners },
    //       { abortEarly: false }
    //     );

    //     setPartnerErrors({ partners: [] });
    //     //.log("✅ Partner validation successful, no errors.");
    //     return true;
    //   } catch (err: any) {
    //     //.log("❌ Partner validation errors found:", err);

    //     // const newErrors: any = { partners: partners.map(() => ({})) };
    //     const newErrors: any = { partners: partners.map(() => ({})) };

    //     if (err.inner && err.inner.length > 0) {
    //       // Multiple validation errors
    //       //.log("Multiple validation errors found:", err.inner);
    //       err.inner.forEach((error: any) => {
    //         if (!error.path) return;

    //         const pathParts = error.path.match(/partners\[(\d+)]\.(\w+)/);
    //         if (pathParts) {
    //           const index = parseInt(pathParts[1], 10);
    //           const field = pathParts[2];

    //           if (!newErrors.partners[index]) {
    //             newErrors.partners[index] = {};
    //           }

    //           newErrors.partners[index][field] = error.message;
    //         }
    //       });
    //     } else {
    //     //.log("Single validation error found:", err);
    //       // Single validation error (not in `inner`)
    //       if (err.path) {
    //         const pathParts = err.path.match(/partners\[(\d+)]\.(\w+)/);
    //         if (pathParts) {
    //           const index = parseInt(pathParts[1], 10);
    //           const field = pathParts[2];

    //           if (!newErrors.partners[index]) {
    //             newErrors.partners[index] = {};
    //           }

    //           newErrors.partners[index][field] = err.message;
    //         }
    //       }
    //     }

    //     //.log("Errors after processing:", JSON.stringify(newErrors, null, 2));
    //     setPartnerErrors(newErrors);
    //     return false;
    //   }
    // };

  const entitySchema = Yup.object().shape({
    entityName: Yup.string().matches(/^[A-Za-z0-9\s\-\/@]+$/, "Only alphabets, numbers, spaces, '-', '/', and '@' are allowed, no other special characters")
    .max(40, "Name must not exceed 40 characters including spaces")
    .required("Firm/Co-operative Society/Company Name is required"),
    entityGstNo: Yup.string()
      .matches(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/, "Invalid GST No. format")
      .required("GST No. is required"),
    entityFpoNo: Yup.string().required("FPO Certificate is required"),
    entityPanNo: Yup.string()
          .matches(
            /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
            "Invalid PAN Card Number (e.g., ABCDE1234F)"
          )
          .required("PAN Card Number is required"),
    entityRegistrationNo: Yup.string().required("Registration No. is required"),
    });

  const handleSubmit = async () => {
    // onNext("")

    //.log('issss repp det filled', isFirmDetailFilled )
    const formattedData = {
      applicationId: applicationId,
      entityName,
      entityRegistrationNo,
      entityGstNo,
      entityPanNo,
      entityFpoNo,
      // firmRepresentatives: partners,
    };
    
    // const isPartnerValid = await  validationPartnerForm();
    const isValid = await validationForm();
    //.log("isPartnerValid", isPartnerValid,isValid);
      //  true false
    if (!isValid ) {
      //.log("Validation failed. Fix errors before submitting.");
      return;
    }
   

    //.log("Final Submitted Data:", formattedData);
    try {
      const res = await submitFirmDetails(formattedData, token);
      //.log("Response from submit:", res);
      if (res.success == false) {
        // alert(`${res.message}`);
        toast.error(`${res.message}`, {position: "top-right", autoClose: 3000,});
      } else {
        onNext(formattedData);
      }
    } catch (error) {
      //.log("Error:", error);
      if(error === "entityGstNo")
        {
        // alert(`${error} already axists`);
        toast.error(`${error} already axists`, {position: "top-right", autoClose: 3000,});
        
        }
        else{
          // alert(`something went wrong ${error}`)
          toast.error(`Something went wrong ${error}`, {position: "top-right", autoClose: 3000,});

        }
    }
  };

  return (
    <div className="card">
      <div className="card-header">
        <h6 className="card-title">
        {formLanguage.firm_details} ({language.firm_details})
        </h6>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="col-form-label">
            {formLanguage.firm_name} ({language.firm_name}) <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={`form-control ${
                errors.entityName ? "is-invalid" : ""
              }`}
              value={entityName}
              onChange={(e) => setEntityName(e.target.value)}
            />
            {errors.entityName && (
              <div className="invalid-feedback d-block">
                {errors.entityName}
              </div>
            )}

            <label className="col-form-label">{formLanguage.firm_gst_no} ({language.firm_gst_no}) <span className="text-danger">*</span></label>
            <input
              type="text"
              className={`form-control ${
                errors.entityGstNo ? "is-invalid" : ""
              }`}
              value={entityGstNo}
              onChange={(e) => setEntityGstNo(e.target.value)}
            />
            {errors.entityGstNo && (
              <div className="invalid-feedback d-block">
                {errors.entityGstNo}
              </div>
            )}

            <label className="col-form-label">
            {formLanguage.fpo} ({language.fpo}) <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={`form-control ${
                errors.entityFpoNo ? "is-invalid" : ""
              }`}
              value={entityFpoNo}
              onChange={(e) => setEntityFpoNo(e.target.value)}
            />
            {errors.entityFpoNo && (
              <div className="invalid-feedback d-block">
                {errors.entityFpoNo}
              </div>
            )}

            <label className="col-form-label">{formLanguage.firm_pan_no} ({language.firm_pan_no}) <span className="text-danger">*</span></label>
            <input
              type="text"
              className={`form-control ${
                errors.entityPanNo ? "is-invalid" : ""
              }`}
              value={entityPanNo}
              onChange={(e) => setEntityPanNo(e.target.value)}
            />
            {errors.entityPanNo && (
              <div className="invalid-feedback d-block">
                {errors.entityPanNo}
              </div>
            )}

            <label className="col-form-label">{formLanguage.firm_registration_no} ({language.firm_registration_no}) <span className="text-danger">*</span></label>
            <input
              type="text"
              className={`form-control ${
                errors.entityRegistrationNo ? "is-invalid" : ""
              }`}
              value={entityRegistrationNo}
              onChange={(e) => setEntityRegistrationNo(e.target.value)}
            />
            {errors.entityRegistrationNo && (
              <div className="invalid-feedback d-block">
                {errors.entityRegistrationNo}
              </div>
            )}
          </div>

          {/* <div className="col-md-6 mb-3">
            <h5 className="text-info">{formLanguage.firm_heading} ({language.firm_heading}) <span className="text-danger">*</span></h5>
            {partners.map((partner:any, index:number) => (
              <div key={index} className="mb-3 border p-2 rounded">
                <label className="col-form-label">{formLanguage.name} ({language.name}) <span className="text-danger">*</span></label>
                <input
                  type="text"
                  className="form-control"
                  value={partner.name}
                  onChange={(e) =>
                    handlePartnerChange(index, "name", e.target.value)
                  }
                />
                 {partnerErrors?.partners?.[index]?.name && (
                    <div className="d-block invalid-feedback">
                      {partnerErrors.partners[index].name}
                    </div>
                  )}

                <label className="col-form-label">{formLanguage.age_in_year}  ({language.age_in_year} )<span className="text-danger">*</span></label>
                <input
                  type="number"
                  className="form-control"
                  value={partner.age}
                  onChange={(e) =>
                    handlePartnerChange(index, "age", e.target.value)
                  }
                />
                    {partnerErrors?.partners?.[index]?.age && (
                    <div className="d-block invalid-feedback">
                      {partnerErrors.partners[index].age}
                    </div>
                  )}

                <label className="col-form-label">{formLanguage.address} ({language.address}) <span className="text-danger">*</span></label>
                <input
                  type="text"
                  className="form-control"
                  value={partner.address}
                  onChange={(e) =>
                    handlePartnerChange(index, "address", e.target.value)
                  }
                />
                      {partnerErrors?.partners?.[index]?.address && (
                      <div className="d-block invalid-feedback">
                        {partnerErrors.partners[index].address}
                      </div>
                  )}
                 {index > 0 && (
                  <button
                    type="button"
                    className="btn btn-danger btn-sm mt-2"
                    onClick={() => handleDeletePartner(index)}
                  >
                    {language.delete}
                  </button>
                )}
              </div>
            ))}

            <button
              type="button"
              className="btn btn-info rounded-pill mt-2"
              onClick={handleAddPartner}
            >
              {language.add}
            </button>
          </div> */}
        </div>
        <div className="d-flex justify-content-start mt-3">
          <button
            type="button"
            className="btn btn-secondary me-4"
            onClick={onPrev}
          >
            {language.previous}
          </button>
          </div>
          <div className="d-flex justify-content-end mt-3">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSubmit}
          >
            {language.next}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Partners;
